export default "__VITE_ASSET__fRK3MBaG__"